import { capitalize } from 'utils/misc';
import uppercase from 'lodash/upperCase';
import { FUEL_TYPES, FUEL_OPTIONS } from 'config/app-config';

export const testId = 'fuelConsumptionTestId';

export type FuelType = typeof FUEL_TYPES[keyof typeof FUEL_TYPES];

type FuelConsumptionProps = {
  fuel?: FuelType;
  consumption?: number;
};

export const FuelConsumption = ({
  fuel,
  consumption
}: FuelConsumptionProps) => {
  const fuelDisplay = capitalize(FUEL_OPTIONS[uppercase(fuel)]);

  return (
    fuel && (
      <span data-testid={testId}>
        <b>{fuelDisplay}: </b>
        {consumption} kWh
      </span>
    )
  );
};
